import Axios from "axios";
import React, { useState, useEffect } from "react";

import Logo from "./assets/techno_logo_black.png";
import { Pagination, SelectInput, TextInput } from "../../components/globals";
// import PickupIndexColumns from './assets/PickupIndexColumns'
import ContentValidation from "../../components/common/ContentValidation";
import TableFilterBox from "../../components/common/TableFilterBox";
import PickupTab from "./components/PickupTab";
import { usePickupState } from "../../context/PickupContext";
import { colors } from "../../utils/colors";
import { QueryClient, QueryClientProvider, useQuery } from "react-query";
import { DEFAULT_PER_PAGE } from "../../helpers/default";
import { generateParams, labelTranslates } from "../../utils/filtering";
import {
  handleKeyDown2,
  onChangeUseState,
} from "../../helpers/FunctionsGlobal";
import PickupIndexColumns from "./components/PickupIndexColumns";
import { PickupsOrderShow } from "./components/PickupsOrderShow";
import { useChecked, useModal } from "../../hooks";
import { fetcherPickups } from "../../utils/react-query";
import { getDateFormat } from "../../helpers/Utils";
import RangePickerComp from "../../components/common/RangePickerComp";
import { paginationCounting } from "../../helpers/number";
import LeftoversTab from "./components/LeftoversTab";

const queryPickupsClient = new QueryClient();

export default function PickupsOrdersScreen() {
  const [tabId, setTabId] = useState("pickups");
  const [rivileStores, setRivileStores] = useState([]);

  useEffect(() => {
    const fetchStores = async () => {
      try {
        const { data } = await Axios.get("/pickups/requests/rivile_stores", {
          params: {
            s: "created_at desc",
          },
        });
        setRivileStores(
          data.map((e) => ({
            label: e.name,
            value: e.id + "",
            id: e.id,
            pickup_address_id: e.pickup_address_id,
          }))
        );
      } catch (err) {
        console.log("Error: ", err);
      }
    };
    fetchStores();
  }, []);

  return (
    <div
      className="col-12"
      style={{ backgroundColor: "#F3F3F3", minHeight: "100vh" }}
    >
      <div className="py-3 mb-1">
        <TopNav />
        <div className="row pt-4 mb-3">
          <div className="col-12">
            <QueryClientProvider client={queryPickupsClient}>
              {tabId == "pickups" ? (
                <PickupsTab
                  tabId={tabId}
                  setTabId={setTabId}
                  rivile_stores={rivileStores}
                />
              ) : (
                <LeftoversTab tabId={tabId} setTabId={setTabId} />
              )}
            </QueryClientProvider>
          </div>
        </div>
      </div>
    </div>
  );
}

const initailPickupsFilters = {
  order_id_order_cont: "",
  order_billing_address_firstname_or_order_billing_address_lastname_or_order_billing_address_phone_or_order_billing_address_company_or_order_billing_address_other_cont_any:
    "",
  shipment_shipment_order_rows_title_or_shipment_shipment_order_rows_order_row_product_reference_cont:
    "",
  order_carrier_id_in: [],
  shipment_shipment_order_rows_pickup_status_in: [],
  order_billing_address_street2_or_order_shipping_address_street2_eq: "",
  shipment_pickup_address_id_in: [],
  created_at: ["", ""],
};

const PickupsTab = ({ tabId, setTabId, rivile_stores }) => {
  const [page, setPage] = useState(1);
  const [filters, setFilters] = useState(initailPickupsFilters);
  const [filterStr, setFilterStr] = useState("");
  const [storeSelectedValue, setStoreSelectedValue] = useState();
  const mergedRivileStores = mergeByPickupAddressId(rivile_stores);
  const [pickupAddressOptions, setPickupAddressOptions] = useState([]);

  const { modalOpt, setModalOpt, closeModal } = useModal();
  const {
    isLoading,
    error,
    data: { totals = 0, data = [], express_total = 0 } = {},
    refetch,
  } = useQuery({
    queryKey: ["requests.json", { page, perPage: DEFAULT_PER_PAGE, filterStr }],
    queryFn: fetcherPickups,
  });

  const handler = () => {
    if (generateParams(filters) == filterStr && page == 1) {
      return refetch();
    }
    setFilterStr(generateParams(filters));
    setPage(1);
  };

  const onChangeFilter = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  function mergeByPickupAddressId(data) {
    const result = [];
    const map = new Map();

    for (const item of data) {
      if (!map.has(item.pickup_address_id)) {
        const newItem = {
          label: item.label,
          value: item.value,
          id: item.id,
          pickup_address_id: item.pickup_address_id,
          ids: [item.id],
        };
        map.set(item.pickup_address_id, newItem);
        result.push(newItem);
      } else {
        const existingItem = map.get(item.pickup_address_id);
        existingItem.ids.push(item.id);
      }
    }

    return result;
  }

  function getIdsById(data, value) {
    const item = data.find((item) => item.value === value);
    return item ? item.ids : [];
  }

  const topPagination = paginationCounting({ page, totals });

  React.useEffect(() => {
    Axios.get('/api/v1/pickup_addresses')
      .then(response => {
        const addresses = response.data.data.map(item => ({
          label: `${item.code}, ${item.address}, ${item.city}`,
          value: item.id
        }));

        setPickupAddressOptions(addresses);
      })
      .catch(error => {
        console.error('Error fetching addresses:', error);
      });
  }, []);

  return (
    <>
      <div className="card">
        <div className="card-body pb-0">
          <div className="row">
            <PickupTab tabId={tabId} setTabId={setTabId} />
            <div className="col-lg-4 d-flex justify-content-center align-items-center">
              <img
                style={{ width: 40 }}
                src="/assets/product-106c1ce8c87a8ec41fc28d459e38a0b7c6abf6659290081019c1e37c3acc0b15.svg"
              />
              <span className="px-2">
                Viso užsakymų
                <b className="ml-1">
                  {totals == 0 && topPagination.startItem == 1
                    ? "0"
                    : `${topPagination.startItem} - ${topPagination.endItem}/${totals}`}
                </b>
              </span>
            </div>
            <div className="col-lg-4 d-flex justify-content-end align-items-center">
              <div
                className="d-flex justify-content-center align-items-center cursor-pointer"
                onClick={() =>
                  onChangeFilter({
                    target: { name: "express", value: !filters.express },
                  })
                }
              >
                <h1
                  className="font-weight-bold mb-0 mr-3"
                  style={{
                    fontSize: 13,
                    color: filters.express ? "#DC3545" : "#000",
                  }}
                >
                  Express
                </h1>

                <div
                  className="text-center"
                  style={{
                    backgroundColor: "#DC3545",
                    borderRadius: 2,
                    minWidth: 30,
                    minHeight: 30,
                    color: "#fff",
                    fontSize: 18,
                  }}
                >
                  {express_total}
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="mt-3" />
        <div
          className="sticky-top sticky-extra bg-white"
          style={{ zIndex: 15 }}
        >
          <TableFilterBox
            button1={
              <React.Fragment>
                <div>
                  <button
                    className="btn btn-sm float-right mr-3 btn-info"
                    onClick={() => setFilters(initailPickupsFilters)}
                  >
                    Išvalyti filtravimą
                  </button>
                  <button
                    className="btn btn-sm float-right mr-3 btn-danger"
                    onClick={handler}
                  >
                    Filtruoti
                  </button>
                </div>
              </React.Fragment>
            }
          >
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(6, 1fr)",
              }}
            >
              <div className="px-1">
                <TextInput
                  placeholder="Įvesti"
                  name="order_id_order_cont"
                  text="Užsakymo nr."
                  value={filters.order_id_order_cont}
                  onKeyDown={handleKeyDown2(handler)}
                  onChange={onChangeFilter}
                />
              </div>
              <div className="px-1">
                <TextInput
                  placeholder="Įvesti"
                  name="order_billing_address_firstname_or_order_billing_address_lastname_or_order_billing_address_phone_or_order_billing_address_company_or_order_billing_address_other_cont_any"
                  text="Klientas"
                  value={
                    filters.order_billing_address_firstname_or_order_billing_address_lastname_or_order_billing_address_phone_or_order_billing_address_company_or_order_billing_address_other_cont_any
                  }
                  onKeyDown={handleKeyDown2(handler)}
                  onChange={onChangeFilter}
                />
              </div>
              <div className="px-1">
                <TextInput
                  placeholder="Įvesti"
                  name="shipment_shipment_order_rows_title_or_shipment_shipment_order_rows_order_row_product_reference_cont"
                  text="Prekė"
                  value={
                    filters.shipment_shipment_order_rows_title_or_shipment_shipment_order_rows_order_row_product_reference_cont
                  }
                  onKeyDown={handleKeyDown2(handler)}
                  onChange={onChangeFilter}
                />
              </div>
              <div className="px-1">
                <SelectInput
                  placeholder="Pasirinkti"
                  label={"Parduotuvė"}
                  options={mergedRivileStores}
                  value={storeSelectedValue}
                  onChange={(value) => {
                    setStoreSelectedValue(() => value);
                    onChangeFilter({
                      target: {
                        name: "order_carrier_id_in",
                        value: getIdsById(mergedRivileStores, value),
                      },
                    });
                  }}
                />
              </div>
              <div className="px-1">
                <SelectInput
                  mode="multiple"
                  placeholder="Pasirinkti"
                  label={"Statusas"}
                  options={[
                    {
                      label: "Nesuruošti",
                      value: "unprepared",
                    },
                    {
                      label: "Suruošti",
                      value: "prepared",
                    },
                    {
                      label: "Iškviestas klientas",
                      value: "client_called",
                    },
                    {
                      label: "Atiduota",
                      value: "give_away",
                    },
                    {
                      label: "Atšauktas",
                      value: "canceled",
                    },
                  ]}
                  value={filters.shipment_shipment_order_rows_pickup_status_in}
                  onChange={(value) =>
                    onChangeFilter({
                      target: { name: "shipment_shipment_order_rows_pickup_status_in", value },
                    })
                  }
                />
              </div>
              <div className="px-1">
                <RangePickerComp
                  label={"Data"}
                  value={
                    filters.created_at
                      ? [
                        getDateFormat(filters.created_at[0]),
                        getDateFormat(filters.created_at[1]),
                      ]
                      : []
                  }
                  onChange={(_, args) => {
                    setFilters((prev) => ({
                      ...prev,
                      ["created_at"]: args,
                    }));
                  }}
                />
              </div>
              <div className="px-1">
                <SelectInput
                  mode="multiple"
                  placeholder="Pasirinkti"
                  label={"Išsiuntimo padaliniai"}
                  options={pickupAddressOptions}
                  value={filters.shipment_pickup_address_id_in}
                  onChange={(value) =>
                    onChangeFilter({
                      target: { name: "shipment_pickup_address_id_in", value },
                    })
                  }
                />
              </div>
            </div>
          </TableFilterBox>
        </div>

        {/* <hr /> */}
        <ContentValidation
          identifier="technorama"
          error={error}
          loader={isLoading}
          array={data}
        >
          <div className="table-responsive">
            <table className="table table-sm table-striped mt-2 mb-0">
              <thead>
                <tr>
                  <th className="text-black">Išsiunt. į padalinį data</th>
                  <th className="text-black">Sukūrimo data</th>
                  <th className="text-black">Užsak. numeris</th>
                  <th className="text-black">Pirkėjas</th>
                  <th className="text-black w-200">Prekės</th>
                  <th className="text-black">Statusas</th>
                  <th className="text-black">Atsiėmimas parduotuvėje</th>
                  <th className="text-black">Mokėjimo būdas</th>
                  <th className="text-black">Vidinis numeris</th>
                  <th className="text-black">Išsiuntimo padalinys</th>
                  <th className="text-black">Suma</th>
                </tr>
              </thead>
              <tbody>
                {data.map((e) => {
                  return (
                    <PickupIndexColumns
                      key={e.id}
                      e={e}
                      refetch={refetch}
                      setShowOrderModal={() => setModalOpt("edit", e.id)}
                    />
                  );
                })}
              </tbody>
            </table>
          </div>
        </ContentValidation>
        <Pagination
          setPagination={setPage}
          page={page}
          totals={totals}
          pageCount={DEFAULT_PER_PAGE}
        />
      </div>
      {modalOpt?.type == "edit" && (
        <PickupsOrderShow
          showOrderModal={modalOpt}
          close={() => {
            closeModal();
            refetch();
          }}
        />
      )}
    </>
  );
};

const TopNav = () => {
  const { user } = usePickupState();

  return (
    <div className="row">
      <div className="col-6 my-auto">
        <a href="/pickups">
          <img className="logo img-fluid" width={200} src={Logo} />
        </a>
      </div>
      <div className="col-6 my-auto">
        <nav className="navbar-expand-sm text-right">
          <div className="navbar-collapse" id="navbar-list-4">
            <ul className="navbar-nav text-right ml-auto">
              <li className="nav-item dropdown">
                <div
                  aria-expanded="false"
                  aria-haspopup="true"
                  className="nav-link dropdown-toggle d-flex align-items-center"
                  data-toggle="dropdown"
                  id="navbarDropdownMenuLink"
                  role="button"
                >
                  <div
                    className="rounded-circle mr-2 d-flex align-items-center justify-content-center text-base text-white"
                    style={{
                      backgroundColor: colors["technorama"],
                      width: 40,
                      height: 40,
                    }}
                  >
                    {user?.title
                      ?.split(" ")
                      .map((s) => s.at(0))
                      .join(" ")}
                  </div>
                  {user?.title}
                </div>
                <div
                  aria-labelledby="navbarDropdownMenuLink"
                  className="dropdown-menu dropdown-menu-right"
                >
                  <a
                    className="dropdown-item text-black"
                    onClick={async () => {
                      await Axios.delete("/pickups/logout.json");
                      window.location.href = "/pickups";
                    }}
                  >
                    Atsijungti
                  </a>
                </div>
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
  );
};
